import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
// mui
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
// component
import { bio_auth } from '@/component/linkMobile/bio';
import Erc20Token from '@/component/send/Erc20Token';
import BaseCoin from '@/component/send/BaseCoin';
import Erc721Token from '@/component/send/Erc721Token';
// lib
import { bioLocalStorage, localGetStorage } from '@/lib/storage';
import { COIN_NAME_NFT } from '@/lib/common/name-space';

export type BioAuthComponentProps = {
  title: string;
  returnUrl: string;
  options: {
    coin: string;
    contractAddress?: string;
  };
};

export default function BioAuthComponent() {
  const { state } = useLocation();
  const { title, returnUrl, options } = state as BioAuthComponentProps;
  const navigate = useNavigate();

  const [isSend, setIsSend] = useState(false);
  const bioType = useRef<'auth' | 'done'>('auth');

  useEffect(() => {
    // 생체인증 등록 여부 확인
    const bioCheck = bioLocalStorage();
    if (bioCheck) {
      // 등록되어 있으면 인증 실행
      executeBioAuth();
    } else {
      // 미등록이면 PIN 화면으로 이동
      navigateToPinComponent();
    }
  }, []);

  useEffect(() => {
    // 앱 콜백 등록
    window.appInterFace = (val: any, data?: any) => {
      handleBioCallback(val, data);
    };

    return () => {
      // cleanup
    };
  }, []);

  const handleBioCallback = (val: string, data?: any) => {
    if (bioType.current === 'auth') {
      if (val === '1') {
        // 인증 성공
        toast.success('생체인증 성공');
        bioType.current = 'done';
        setIsSend(true);
      } else {
        // 인증 실패 - PIN 입력으로 폴백
        toast.error('생체인증 실패. PIN 입력으로 전환합니다.');
        navigateToPinComponent();
      }
    }
  };

  const executeBioAuth = () => {
    // 생체인증 실행 (인증만, 값은 앱에 저장된 것 사용)
    bio_auth(false, '');
  };

  const navigateToPinComponent = () => {
    navigate('/pinComponent', {
      state: {
        pinType: 'confirm',
        title,
        returnUrl,
        options,
      },
      replace: true,
    });
  };

  const SendType = () => {
    if (options.coin === COIN_NAME_NFT) {
      return <Erc721Token />;
    } else if (options.contractAddress) {
      return <Erc20Token contractAddress={options.contractAddress} symbol={options.coin} />;
    } else {
      return <BaseCoin symbol={options.coin} />;
    }
  };

  if (isSend) {
    return SendType();
  }

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress size={60} />
        <Typography variant="h6" mt={3}>
          생체인증 진행 중...
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1}>
          인증해 주세요
        </Typography>
      </Box>
    </Container>
  );
}
